import React, { useEffect, useState } from "react";
import "./ImgStyle.css";
import { Box } from "@mui/material";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';

function PopupImg(props) {
  const { alt, src, filename, width, height } = props;
  const [imgwidth, setimgwidth] = useState("50%");
  const [imgheight, setimgheight] = useState("50%");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (width) {
      setimgwidth(width);
    }
    if (height) {
      setimgheight(height);
    }
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '70%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    boxShadow: 24,
    borderRadius: '20px'
  };

  return (
    <div>
      <div className="container">
        <img src={src} alt={alt} onClick={handleOpen} style={{ cursor: 'pointer' }} />
        <br />
        {filename}
        <Modal
          open={open}
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
        >
          <Box sx={{ ...modalStyle }}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1} ></Box>
              <Box>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box sx={{ marginTop: 3 }} display="flex" justifyContent="center" >
              <img className="imgz" src={src} alt={alt} />
            </Box>
          </Box>
        </Modal>
      </div>
      <br />
      <br />
    </div>
  );
}

export default PopupImg;
